module.exports = __webpack_public_path__ + "static/beauty9-5c704690722ae1deca627b544bf4f1da.jpg";